module.exports = __webpack_public_path__ + "static/img/img2.941c8cdd.png";